import {
  Alert,
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import React, { Fragment, useState, useContext } from "react";
import PropTypes from "prop-types";
import PageHeader from "../common/PageHeader";
import FalconCardHeader from "../common/FalconCardHeader";
import withRedirect from "../../helpers/hoc/withRedirect";
import ButtonIcon from "../common/ButtonIcon";
import {
  faFilter,
  faInfoCircle,
  faPlus,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import {
  deleteAliquot,
  deleteIncome,
  fetchIndividualIncome,
} from "../../helpers/api/finance";
import EditIncomeModal from "./EditIncomeModal";
import { isIterableArray } from "../../helpers/utils";
import FullPagination from "../common/pagination/FullPagination";
import { useSelector } from "react-redux";
import AliquotListItem from "../common/AliquotListItem";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import { Toast } from "./../UI/toast/Toast";
import Swal from "sweetalert2";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import { Link } from "react-router-dom";
import Datetime from "react-datetime";
import { Message, Or, PreloadState } from "../UI/preloading/PreloadState";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SupportLink from "../root/support/components/SupportLink";
import NumberFormat from "react-number-format";
import moment from "moment";
import useSWRFetchPaginationProperty from "../../helpers/hooks/useSWRFetchPaginationProperty";
import { fetchProperties } from "../../helpers/api/condominium";
import Filter from "../common/Filter";
import { CurrencyContext } from "../../context/Context";
import useModuleBase from "../../helpers/hooks/useModuleBase";

const filter_options = [
  { value: "pending", displayName: "Pendientes (planilla)", disabled: false },
  { value: "issued", displayName: "Emitidos en planilla", disabled: false },
  { value: "cash", displayName: "Caja", disabled: false },
];

const IndividualIncome = ({
  setRedirect,
  setRedirectUrl,
  showPagination = true,
}) => {
  const moduleBase = useModuleBase();

  const { id } = useParams();
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { baseCurrency } = useContext(CurrencyContext);
  const [params, setParams] = useState({
    state: 0,
    condominiumId: id,
    start_date: null,
    end_date: null,
    view: "pending",
  });
  const [formDate, setformDate] = useState({
    since: null,
    to: null,
  });

  const [param, setParam] = useState({
    condominiumId: selectedCondominium,
    search: null,
  });

  const {
    data: propertiesData,
    error: err,
    isLoading: propertiesIsLoading,
    meta: propertiesMeta,
    handler: {
      nextPage: propertiesNextPage,
      previousPage: propertiesPreviousPage,
      perPage: propertiesPerPage,
      goToPage: propertiesGoToPage,
    },
  } = useSWRFetchPaginationProperty(fetchProperties, param);

  const {
    data,
    error,
    isLoading,
    meta,
    mutate,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(fetchIndividualIncome, params);

  const [selectedIncome, setSelectedIncome] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const handleEdit = (incomeItem) => {
    setSelectedIncome(incomeItem);
    setIsEditModalOpen(true);
  };

  const handleDelete = (incomeId) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "¿Quieres eliminar este ingreso?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#9341af",
      cancelButtonColor: "#bbb",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.value) {
        try {
          const { code } = await deleteIncome(incomeId);
          if (code === "H0004" || code === "H0000" || code === "OK" || code === 200) {
            Toast.fire({
              type: "success",
              title: "Ingreso eliminado exitosamente.",
            });
            mutate();
          }
        } catch (error) {
          handleErrorMessage(error);
        }
      }
    });
  };

  const ButtonAdd = ({ onClick }) => {
    return (
      <ButtonIcon color="falcon-default" onClick={onClick} icon={faPlus}>
        Añadir ingreso individual
      </ButtonIcon>
    );
  };

  const handleCreateIndividialIncome = () => {
    setRedirectUrl(`/dashboard/${moduleBase}/${id}/individual-income/create`);
    setRedirect(true);
  };

  /*     const renderItems = () => {
        return data.map((aliquot, i) => {
            return <AliquotListItem
                key={aliquot.id}
                amount={aliquot.value}
                name={`${aliquot.property.user.data.firstname} ${aliquot.property.user.data.lastname}`}
                description={aliquot.description}
                handleEdit={() => handleEdit(aliquot.id)}
                createdAt={aliquot.created_at}
                handleDelete={() => handleDelete(aliquot.id)}
                options={true}
            />
        })
    } */

  return (
    <>
      <PageHeader
        title="Ingresos individuales"
        titleTag="h2"
        description="Gestiona y administra cada una de tus finanzas."
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <Card>
        <FalconCardHeader title="Ingresos individuales">
          <Row className="mb-3">
            <Col md={4} lg={3}>
              <Filter
                keyField="view"
                options={filter_options}
                selectType={setParams}
                dateFilter={false}
              />
            </Col>
          </Row>
          <Row className="justify-content-end">
            <Col xs="auto" xl={12} lg={12} md={12} sm={12}>
              <Row className="justify-content-center align-items-center">
                <Col
                  xs="auto"
                  lg="auto"
                  md={12}
                  sm={12}
                  className="d-flex align-items-center justify-content-center"
                >
                  <Label className="mb-0 mr-2">
                    <FontAwesomeIcon icon={faFilter} />
                  </Label>
                </Col>
                <Col
                  xs="auto"
                  sm="auto"
                  lg="auto"
                  className="d-flex align-items-center flex-sm-column flex-md-column flex-lg-row"
                >
                  <Label className="mr-2 mb-0">Desde</Label>
                  <Datetime
                    value={formDate.since}
                    isValidDate={(current, selected) => {
                      return !current.isAfter();
                    }}
                    onChange={(d) =>
                      setformDate((prev) => ({ ...prev, since: d }))
                    }
                    dateFormat="DD/MM/YYYY"
                    timeFormat={false}
                  />
                </Col>
                <Col
                  xs="auto"
                  sm="auto"
                  lg="auto"
                  className="d-flex align-items-center flex-sm-column flex-md-column flex-lg-row"
                >
                  <Label className="mr-2 mb-0">Hasta</Label>
                  <Datetime
                    value={formDate.to}
                    className="mr-2"
                    isValidDate={(current, selected) => {
                      return (
                        current.isAfter(formDate.since) && !current.isAfter()
                      );
                    }}
                    dateFormat="DD/MM/YYYY"
                    timeFormat={false}
                    onChange={(d) =>
                      setformDate((prev) => ({ ...prev, to: d }))
                    }
                  />
                </Col>
                <Col
                  xs="auto"
                  className="pl-0 d-flex align-items-md-end align-items-lg-center align-items-sm-end"
                >
                  <ButtonIcon
                    className="text-nowrap btn-block"
                    disabled={!formDate.to ? true : false}
                    icon={faSearch}
                    color="falcon-default"
                    onClick={() => {
                      setParams((prev) => {
                        return {
                          ...prev,
                          start_date: formDate.since.format("YYYY-MM-DD"),
                          end_date: formDate.to.format("YYYY-MM-DD"),
                        };
                      });
                    }}
                  >
                    Buscar
                  </ButtonIcon>
                </Col>
              </Row>
            </Col>
            <Col xs="auto" lg="auto" md={12} sm={12} className="mt-3">
              <ButtonAdd onClick={handleCreateIndividialIncome} />
            </Col>
          </Row>
        </FalconCardHeader>
        <CardBody className={isIterableArray(data) ? "p-0" : ""}>
          <PreloadState cond={isIterableArray(data)} loading={isLoading}>
            {isIterableArray(data) && data.length > 0 ? (
              <>
                {data.map((cost, index) => (
                  <Fragment key={index}>
                    <Col className=" shadow-none border-top">
                      <Row className="mb-3 mt-3">
                        <Col className="d-flex align-items-center">
                          <div className="media-body">
                            <h6 className="mb-0 font-weight-semi-bold">
                              <span className="text-900">
                                <p className="m-0">{cost.name} </p>
                              </span>
                            </h6>
                            {cost?.property_id &&
                              isIterableArray(propertiesData) &&
                              propertiesData.map((move, pIdx) => {
                                if (
                                  Number(move?.id) === Number(cost?.property_id)
                                ) {
                                  return (
                                    <h6 key={pIdx} className="m-0 mt-2">
                                      {move?.user?.data?.firstname}{" "}
                                      {move?.user?.data?.lastname}
                                    </h6>
                                  );
                                }
                                return null;
                              })}
                            <p className="m-0">{cost.description}</p>
                            <p className="m-0">
                              creada el{" "}
                              {moment(cost.created_at).format("DD-MM-YYYY")}
                            </p>
                            {cost.period?.name && (
                              <Badge className="rounded-capsule badge-soft-success">
                                Emitido en {cost.period.name}
                              </Badge>
                            )}
                          </div>
                        </Col>
                        <Col>
                          <Row>
                            <Col>
                              <p className="text-right">Monto</p>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <h5 className="text-right">
                                <NumberFormat
                                  prefix={`${baseCurrency.symbol} `}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  thousandSeparator={true}
                                  displayType="text"
                                  value={cost.amount}
                                />
                              </h5>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs="auto" className="d-sm-flex align-items-center">
                          <UncontrolledDropdown
                            direction="left"
                            className="d-inline-block ml-2"
                          >
                            <DropdownToggle color="falcon-default" size="sm">
                              <FontAwesomeIcon icon="ellipsis-h" />
                            </DropdownToggle>
                            <DropdownMenu>
                              {!cost.period_id && !cost.period?.name ? (
                                <>
                                  <DropdownItem onClick={() => handleEdit(cost)}>
                                    Editar
                                  </DropdownItem>
                                  <DropdownItem
                                    className="text-danger"
                                    onClick={() => handleDelete(cost.id)}
                                  >
                                    Eliminar
                                  </DropdownItem>
                                </>
                              ) : (
                                <DropdownItem disabled>
                                  Emitido en planilla (no editable)
                                </DropdownItem>
                              )}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </Col>
                      </Row>
                    </Col>
                  </Fragment>
                ))}
              </>
            ) : (
              <Row className="p-card">
                <Col>
                  <Alert color="info" className="mb-0">
                    Al parecer aún no hay ingresos para mostrar. Puedes crear
                    uno ahora mismo pulsando el siguiente enlace
                    <Button
                      data-testid="Button"
                      tag={Link}
                      color="link"
                      size="sm"
                      className="ml-1 pl-0"
                      to={`/dashboard/${moduleBase}/${selectedCondominium}/individual-income/create`}
                    >
                      Crear ingreso individual
                    </Button>
                  </Alert>
                </Col>
              </Row>
            )}
            {showPagination && (
              <FullPagination
                nextPage={nextPage}
                prevPage={previousPage}
                goToPage={goToPage}
                meta={meta}
                className={"shadow-none"}
                posText={"Ingresos individuales"}
                perPage={perPage}
              />
            )}
          </PreloadState>
        </CardBody>
      </Card>
      <EditIncomeModal
        isOpen={isEditModalOpen}
        toggle={() => setIsEditModalOpen(!isEditModalOpen)}
        income={selectedIncome}
        condominiumId={selectedCondominium || id}
        onSuccess={() => mutate()}
      />
    </>
  );
};

IndividualIncome.propTypes = {
  showPagination: PropTypes.bool,
};

export default withRedirect(IndividualIncome);
